import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Autocomplete, Button, Grid, TextField, Box } from "@mui/material";
import { getServiceCity } from "redux/actions/UserServiceCity";
import { getChooseYourService } from "redux/actions/UserChooseYourService";
import {
  getCoupon,
  getDeleteCoupon,
  patchUpdateCoupon,
  postAddCoupon,
  updateCouponStatus,
} from "redux/actions/UserCouponAction";
import Loader from "components/loader/Loader";
import CommonBreadCrumb from "components/commonBreadCrumb/CommonBreadCrumb";
import CommonTable from "components/commonTable/CommonTable";
import CommonDialog from "components/commonDialog/CommonDialog";
import SearchBar from "components/commonSearch/SearchBar";
import { couponFormData } from "./CouponFormData";
import { debounce } from "lodash";
import useModal from "components/hooks/useModel";
import { dateFormate, handlePermissions } from "utils/utils";
import { roleAndPermissionEnum } from "utils/rolesPermissionsEnum";
import LocationDropdown from "components/LocationDropdown/LocationDropdown";
import { toast } from "react-toastify";
import { API_ENDPOINT } from "services/Api";
import { FormDialog } from "components/ui/form-dialog";
import highlightOrderService from "services/HighlightOrderService";
import CommonFormNew from "components/commonFormNew/commonFormNew";
import './CouponTable.scss'; 
import dayjs from "dayjs";

function CouponTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const id = localStorage.getItem("companyId");
  const { open: open, toggle: setOpen } = useModal();
  const { open: openConfirm, toggle: setOpenConfirm } = useModal();
  const [type, setType] = useState("Create");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [search, setSearch] = useState("");
  const [defaultValue, setDefaultValue] = useState({});
  const [selectedImage, setSelectedImage] = useState("");
  const [deleteId, setDeleteId] = useState("");
  const [addToHighlightBannerId, setAddToHighlightBannerId] = useState(null);
  const [highlightCity, setHighlightCity] = useState([]);
  const [addToHighlightFormData, setAddToHighlightFormData] = useState({
    title: "",
    image: null,
    dateRange: { startDate: null, endDate: null },
    city: null,
    // link: "",
  });
  const locationData = useSelector(
    (state) => state?.userServiceCity?.userServiceCity?.data
  );
  const dutyTypeOptions = useSelector(
    (state) => state?.userChooseYourService?.userChooseYourService?.data
  );
  const tableData = useSelector((state) => state?.userCoupon?.userCoupon?.data);
  const loader = useSelector((state) => state?.userCoupon?.loading);
  const selectedLocation = useSelector(
    (state) => state?.locationDropdown?.selectedLocation
  );

  const data = {
    id: id,
    type: "Company",
    businessType: 0,
  };

  let filterData = {
    page: page,
    pageSize: rowsPerPage,
    search: search,
    location: selectedLocation?.id,
  };

  useEffect(() => {
    dispatch(getServiceCity());
    dispatch(getChooseYourService(data));
    dispatch(getCoupon({ ...filterData, location: selectedLocation?.id }));
  }, [selectedLocation, page, rowsPerPage, search]);

  // Move table data transformation to a separate function
  const transformTableData = (rawData) => {
    if (!rawData) return { header: [], body: [], totalCount: 0 };

    return {
      header: rawData.header || [],
      body: Array.isArray(rawData.body)
        ? rawData.body.map((item) => ({
            ...item,
            title: item.title, // Keep the original title
            perventageValue: item?.discountValue,
          }))
        : [],
      totalCount: rawData.totalCount || 0,
    };
  };

  // Transform table data before passing to CommonTable
  const tableDataToDisplay = transformTableData(tableData);

  console.log("tableDataToDisplay:", tableDataToDisplay);

  // Page Change
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getCoupon({ ...filterData, page: newPage }));
  };

  // PageSize change
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getCoupon({
        ...filterData,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  // City Filter Added
  const onInputChange = (data) => {
    // setLocValue(data);
    // setLocId(data?.id);
    console.log("location:", data?.id);
    dispatch(getCoupon({ ...filterData, location: data?.id }));
  };

  // Search
  const onSearch = debounce((e) => {
    setPage(0);
    setSearch(e);
    const searchFilterData = {
      ...filterData,
      search: e,
      page: 0,
    };
    dispatch(getCoupon(searchFilterData));
  }, 1000);

  const onClickTableDriver = (val) => {
    navigate("/coupon/details", {
      state: {
        couponId: val?.id,
        couponCode: val?.couponCode,
      },
    });
  };

  const handleOpenDialog = () => {
    setType("create");
    setOpen(true);
    setDefaultValue({});
  };

  const onImageHandleChange = (data) => {
    setSelectedImage(data);
  };

  // Add Coupon
  const onDialog = (data, code, quillValue, image, csv) => {
    const couponForm = {
      couponCode: data?.couponCode,
      title: data?.title,
      discountType: data?.discountType,
      discountValue: data?.discountValue || data?.perventageValue,
      minBookingAmount: data?.minBookingAmount,
      individualUsageLimit: data?.individualUsageLimit,
      category: data?.category,
      description: data?.description,
      terms_conditions: data?.terms_conditions,
      isDraft: data?.isDraft || false,
      isB2B: true,
    };

    // Only add overallUsageLimit if category is not Referral
    if (data?.category !== "Referral") {
      couponForm.overallUsageLimit = data?.overallUsageLimit;
    }

    // Add referralType if category is Referral
    if (data?.category === "Referral") {
      couponForm.referralType = data?.referralType;
    }

    let formData = new FormData();

    if (type === "edit" || type === "Edit") {
      // Compare with defaultValue to find changed fields
      const changedFields = {};
      Object.keys(couponForm).forEach((key) => {
        if (couponForm[key] !== defaultValue[key]) {
          changedFields[key] = couponForm[key];
        }
      });

      if (data?.isDraft) {
        changedFields.isDraft = true;
      } else {
        changedFields.isDraft = false;
      }

      // Check if dates changed
      if (data?.duration) {
        const oldStartDate = new Date(defaultValue.startDate).getTime();
        const oldEndDate = new Date(defaultValue.endDate).getTime();
        const newStartDate = new Date(data.duration[0]).getTime();
        const newEndDate = new Date(data.duration[1]).getTime();

        if (oldStartDate !== newStartDate) {
          formData.append(
            "startDate",
            dateFormate(data?.duration[0], "toIsoString")
          );
        }
        if (oldEndDate !== newEndDate) {
          formData.append(
            "endDate",
            dateFormate(data?.duration[1], "toIsoString")
          );
        }
      }

      let initialState = {};

      Object.keys(defaultValues).forEach((key) => {
        if (Array.isArray(defaultValues[key])) {
          initialState[key] = defaultValues[key];
          // Handle special case mappings
          if (key === "Services") {
            initialState["dutyTypes"] = defaultValues[key];
          }
          if (key === "ServiceCities") {
            initialState["city"] = defaultValues[key];
          }
        }
      });

      setDefaultValue({
        ...defaultValue,
        ...initialState,
      });

      // Check if cities changed
      if (
        data?.city &&
        JSON.stringify(initialState.city.map((c) => c.id)) !==
          JSON.stringify(data.city.map((c) => c.id))
      ) {
        formData.append(
          "cities",
          JSON.stringify(data?.city?.map((list) => list.id))
        );
      }

      // Check if duty types changed
      if (
        data?.dutyTypes &&
        JSON.stringify(initialState.dutyTypes.map((d) => d.id)) !==
          JSON.stringify(data.dutyTypes.map((d) => d.id))
      ) {
        formData.append(
          "dutyTypes",
          JSON.stringify(data?.dutyTypes?.map((list) => list.id))
        );
      }

      // Check banner settings changes
      const oldBannerMeta = defaultValue.isBanner || {};
      if (data?.isBanner !== oldBannerMeta) {
        formData.append("isBanner", data?.isBanner || false);
      }

      // Only append changed fields
      Object.keys(changedFields).forEach((key) => {
        formData.append(key, changedFields[key]);
      });

      // Check if new image is provided
      if (image instanceof File) {
        formData.append("couponImage", image);
      }

      // Check if new CSV is provided for Individual category
      if (data?.category === "Individual" && csv instanceof File) {
        formData.append("usersList", csv);
      }

      // Handle Flash category user type change
      if (
        data?.category === "Flash" &&
        data?.isNewUser !== defaultValue?.isNewUser
      ) {
        formData.append(
          "isNewUser",
          data?.isNewUser === "isNewUser" ? true : false
        );
      }

      // Add maxDiscountValue only if changed and discount type is Percentage
      if (
        data?.discountType === "Percentage" &&
        data?.maxDiscountValue !== defaultValue?.maxDiscountValue
      ) {
        formData.append("maxDiscountValue", data?.maxDiscountValue);
      }

      dispatch(
        patchUpdateCoupon({
          id: defaultValue.id,
          data: formData,
          page: page,
          pageSize: rowsPerPage,
          search: search,
          status: filterData.status,
          isB2B: true,
        })
      );
      setOpen(false);
    } else {
      // For create mode, keep existing logic
      if (image instanceof File) {
        formData.append("couponImage", image);
      }

      formData.append(
        "startDate",
        dateFormate(data?.duration[0], "toIsoString")
      );
      formData.append("endDate", dateFormate(data?.duration[1], "toIsoString"));

      if (data?.isBanner) {
        formData.append("isBanner", true);
      }

      formData.append(
        "cities",
        JSON.stringify(data?.city?.map((list) => list.id))
      );
      formData.append(
        "dutyTypes",
        JSON.stringify(data?.dutyTypes?.map((list) => list.id))
      );

      if (data?.category === "Individual" && csv instanceof File) {
        formData.append("usersList", csv);
      }
      if (data?.category === "Flash") {
        formData.append(
          "isNewUser",
          data?.isNewUser === "isNewUser" ? true : false
        );
      }

      if (data?.discountType === "Percentage") {
        formData.append("maxDiscountValue", data?.maxDiscountValue);
      }

      Object.keys(couponForm).forEach((key) => {
        if (couponForm[key] !== undefined && couponForm[key] !== null) {
          formData.append(key, couponForm[key]);
        }
      });

      dispatch(postAddCoupon(formData, setOpen));
    }
  };

  //MoreIcon Click
  const onClickMoreIcon = async (data, typeVal) => {
    if (typeVal === "Activate" || typeVal === "Deactivate") {
      const newStatus = typeVal === "Activate" ? "Active" : "Inactive";

      try {
        if (data.isDraft) {
          // Keep existing draft logic
          dispatch(
            patchUpdateCoupon({
              id: data.id,
              data: {
                status: newStatus,
                isDraft: false,
              },
              page: page,
              pageSize: rowsPerPage,
              search: search,
              status: filterData.status,
              isB2B: true,
            })
          );
        } else {
          // Direct API call for status update
          const response = await fetch(
            `${process.env.REACT_APP_B2B_API_BASE_URL}${API_ENDPOINT.couponApi.status}/${data.id}`,
            {
              method: "PATCH",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${localStorage.getItem("token")}`, // Add if you need auth
              },
              body: JSON.stringify({ status: newStatus }),
            }
          );

          const result = await response.json();

          if (result.success) {
            toast.success("Status updated successfully");
            // Refresh the coupon list
            dispatch(
              getCoupon({
                page,
                pageSize: rowsPerPage,
                search,
                status: filterData.status,
              })
            );
          } else {
            throw new Error(result.message || "Failed to update status");
          }
        }
      } catch (error) {
        toast.error(error.message || "Failed to update coupon status");
      }
    } else if (typeVal === "Delete") {
      setOpenConfirm(true);
      setDeleteId(data.id);
    } else if (typeVal === "Edit" && data.status == "Draft") {
      setType("edit");
      setDefaultValue(data);
      setOpen(true);
    } else if (
      typeVal === "+ Add to highlight" &&
      data.status == "Active" &&
      data.isBanner
    ) {
      setHighlightCity([{ id: "all", name: "All City" }, ...data?.ServiceCities]);
      setDefaultValue(data);
      setAddToHighlightBannerId(data.id);
    } else if (typeVal === "Copy Coupon") {
      setType("Copy");
      setDefaultValue({
        ...data,
        couponCode: "",
        title: "",
        startDate: "",
        endDate: "",
        image: {},
      });
      setOpen(true);
    }
  };

  const getMoreIconOptions = (data) => {
    const options = [];

    if (data.isDraft) {
      options.push({ id: 1, name: "Edit" });
    }

    if (data.status === "Active") {
      options.push({ id: 2, name: "Deactivate" });
    } else if (data.status === "InActive") {
      options.push({ id: 3, name: "Activate" });
    }

    options.push({ id: 4, name: "Delete" });
    return options;
  };

  const defaultValues = {
    ...defaultValue,
    isNewUser:
      type === "edit"
        ? defaultValue?.isNewUser
          ? "isNewUser"
          : "existingUser"
        : "",
  };

  const onDelete = () => {
    const val = {
      couponID: {
        id: deleteId,
        filterData: filterData,
      },
      setOpenConfirm: setOpenConfirm,
      key: "couponTable",
    };
    dispatch(getDeleteCoupon(val));
  };

  const breadcrumbPaths = [{ name: "Coupon", url: "", className: "colorBlue" }];

  //roles and permissions
  const roleAndPermissions = useSelector(
    (state) => state?.getRolesAndPermissions?.rolesAndPermissions
  );
  const configRoleEnum = roleAndPermissionEnum.configuration;

  const accessForall = handlePermissions(
    roleAndPermissions,
    configRoleEnum.moduleKey,
    { defaultAllAccess: configRoleEnum?.subModules?.coupon?.all }
  );

  const accessForEdit = handlePermissions(
    roleAndPermissions,
    configRoleEnum.moduleKey,
    { customAccess: configRoleEnum?.subModules?.coupon?.edit }
  );

  const accessForAdd = handlePermissions(
    roleAndPermissions,
    configRoleEnum.moduleKey,
    { customAccess: configRoleEnum?.subModules?.coupon?.add }
  );

  const accessForDelete = handlePermissions(
    roleAndPermissions,
    configRoleEnum.moduleKey,
    { customAccess: configRoleEnum?.subModules?.coupon?.delete }
  );
  const hasViewMoreIcon = accessForall || accessForEdit || accessForDelete;

  // const addAccess = accessForall || accessForAdd;
  const addAccess = true

  const [formState, setFormState] = useState({
    category: "",
    discountType: "",
  });

  const handleDependentFieldChange = (fieldName, value) => {
    setFormState((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const addToHightlightFields = [
    {
      name: "dateRange",
      label: "Duration",
      type: "dateRange",
      required: true,
      placeholder: "Duration",
      minDate: dayjs().add(1, "day").startOf("day"),
      
    },
    {
      name: "city",
      label: "City",
      type: "city",
      required: true,
      placeholder: "City",
    },
  ];

  const handleAddToHighLight = async () => {
    try {
      const payload = {
        type: "coupon",
        referenceId: addToHighlightBannerId,
        locations: addToHighlightFormData.city.map((itm) => itm.id),
        startDate: addToHighlightFormData.dateRange?.startDate
          ? dateFormate(
              new Date(
                Date.UTC(
                  new Date(
                    addToHighlightFormData.dateRange.startDate
                  ).getFullYear(),
                  new Date(
                    addToHighlightFormData.dateRange.startDate
                  ).getMonth(),
                  new Date(
                    addToHighlightFormData.dateRange.startDate
                  ).getDate(),
                  0,
                  0,
                  0,
                  0
                )
              ),
              "toIsoString"
            )
          : "",
        endDate: addToHighlightFormData.dateRange?.endDate
          ? dateFormate(
              new Date(
                Date.UTC(
                  new Date(
                    addToHighlightFormData.dateRange.endDate
                  ).getFullYear(),
                  new Date(addToHighlightFormData.dateRange.endDate).getMonth(),
                  new Date(addToHighlightFormData.dateRange.endDate).getDate(),
                  0,
                  0,
                  0,
                  0
                )
              ),
              "toIsoString"
            )
          : "",
      };

      await highlightOrderService.addToHighLight(payload);
      toast.success("Coupon added to highlight successfully");
      setAddToHighlightFormData({
        title: "",
        image: null,
        dateRange: { startDate: null, endDate: null },
        city: null,
      });
    } catch (error) {
      console.log("err", error, error.response?.data);
      toast.error(
        error.response?.data?.message || "Failed to add coupon to highlight"
      );
    } finally {
      setAddToHighlightBannerId(null);
    }
  };

  function isFormValid(form, fields) {
    return fields.every((field) => {
      if (!field.required) return true;

      const fieldValue = form[field.name];

      switch (field.type) {
        case "input":
          return fieldValue && fieldValue.trim() !== "";
        case "image":
          return fieldValue !== null && fieldValue !== undefined;
        case "dateRange":
          return (
            fieldValue &&
            fieldValue.startDate &&
            fieldValue.endDate &&
            (Array.isArray(form?.city)
              ? form?.city?.length > 0
              : form?.city !== null)
          );
        default:
          return (
            fieldValue !== null && fieldValue !== undefined && fieldValue !== ""
          );
      }
    });
  }

  const isValid = isFormValid(addToHighlightFormData, addToHightlightFields);

  return (
    <div>
      <Grid
        container
        direction="row"
        justifyContent={{
          xs: "flex-start",
          sm: "flex-start",
          md: "flex-end",
          lg: "flex-end",
        }}
        sx={{ mb: 2 }}
        spacing={{ xs: 1, sm: 1, md: 2, lg: 2 }}
        item
        lg={12}
        md={12}
        sm={12}
        xs={12}
      >
        <Grid item lg={2} md={3} sm={12} xs={12}>
          <LocationDropdown
            onChange={onInputChange}
            className="location-dropdown"
            fullWidth
          />
        </Grid>
        <Grid item lg={2} md={3} sm={12} xs={12} sx={{ display: "flex", justifyContent: { xs: "flex-start", sm: "flex-start", md: "flex-end", lg: "flex-end" } }}>
          <SearchBar onSearchQuery={onSearch} search={search} fullWidth />
        </Grid>

        <Grid item lg="auto" md="auto" sm={12} xs={12} sx={{ display: "flex", justifyContent: { xs: "flex-start", sm: "flex-start", md: "flex-end", lg: "flex-end" }, width: { xs: '100%', sm: '100%', md: 'auto', lg: 'auto' } }}>
          {addAccess && (
            <Button className="configaddBtn" onClick={handleOpenDialog} fullWidth>
              + Add Coupon
            </Button>
          )}
        </Grid>
      </Grid>

      {/* Table Data */}
      {loader ? (
        <Loader />
      ) : (
        <CommonTable
          data={tableDataToDisplay}
          onClickTableVendor={onClickTableDriver}
          tableOnClickRow={(navigate, val) => onClickTableDriver(val)}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          tabName={"coupon"}
          isClickable={true}
          onClickMoreIcon={onClickMoreIcon}
          viewMoreIcon={!hasViewMoreIcon}
        />
      )}

      {open ? (
        <CommonDialog
          className="marginbottom20"
          open={open}
          handleClose={() => setOpen(false)}
          toggle={setOpen}
          formData={couponFormData(
            type,
            locationData,
            dutyTypeOptions,
            formState.category,
            formState.discountType
          )}
          button={"dialogButton"}
          onSubmittBtn={onDialog}
          selectType={type}
          type={type === "edit" ? "Edit Coupon" : type === "Copy" ? "Coupon" : type === "create" ? "Coupon" : "Coupon"}
          defaultValues={defaultValues}
          onImageHandleChange={onImageHandleChange}
          formName={"couponForm"}
          onDependentFieldChange={handleDependentFieldChange}
          enableSaveAsDraft={true}
        />
      ) : null}

      {openConfirm ? (
        <CommonDialog
          open={openConfirm}
          handleClose={() => setOpenConfirm(false)}
          toggle={setOpenConfirm}
          onConfirmDialog={onDelete}
          text={"Are you sure to delete this coupon?"}
          selectType={"delete"}
          dialogContent={"couponDelete"}
          typeOfDialog="Coupon"
        />
      ) : null}

      {addToHighlightBannerId && (
        <FormDialog
          title={"Add"}
          subtitle={"To Highlight"}
          isOpen={addToHighlightBannerId}
          onOpenChange={setAddToHighlightBannerId}
          onSubmit={handleAddToHighLight}
          onCancel={() => setAddToHighlightBannerId(null)}
          submitLabel={"Add"}
          submitDisabled={!isValid}
          hideCancel={true}
        >
          <p className="text-sm text-amber-600 bg-amber-50 border border-amber-200 rounded-md px-3 py-2 mb-2">
              Highlights must be configured at least one day in advance. Please select tomorrow or a later date.
            </p>
          <CommonFormNew
            config={addToHightlightFields}
            formData={addToHighlightFormData}
            onFormDataChange={setAddToHighlightFormData}
            cityOptions={highlightCity}
            maxTimeDuration={{
              startDate: defaultValue?.startDate,
              endDate: defaultValue?.endDate,
            }}
          />
        </FormDialog>
      )}
    </div>
  );
}

export default CouponTable;
